import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const voteGenerate = {
  fetchVoteGenerates: lazyModuleMethod(
    () => import('./fetchVoteGenerates'),
    'default'
  ),
  createVoteGenerate: lazyModuleMethod(
    () => import('./createVoteGenerate'),
    'default'
  ),
  updateVoteGenerate: lazyModuleMethod(
    () => import('./updateVoteGenerate'),
    'default'
  ),
}
